import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Table, Modal } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import ProductTable from "../ProductTable";
const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    }
};
class OverviewTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeProduct: null,
            modalOpen: false
        };
    }

    render() {


        return (
            <div>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>{this.props.translate("inventory.table.header.code")}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate("inventory.table.header.name")}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate("inventory.table.header.inStock")}</Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.products.sort((a, b) => {
                            if (a.code < b.code) return -1;
                            if (a.code > b.code) return 1;
                            return 0;
                        })
                            .map((product) => {

                                return (
                                    <Table.Row key={product.id}>
                                        <Table.Cell>{product.code}</Table.Cell>
                                        <Table.Cell>{product.name}</Table.Cell>
                                        <Table.Cell>{product.inStock}</Table.Cell>
                                        <Table.Cell><Button primary onClick={() => {this.setState({activeProduct: product, modalOpen: true})}}>Edit</Button></Table.Cell>
                                    </Table.Row>
                                );

                            })}
                    </Table.Body>
                </Table>
                <Modal
                    size='fullscreen'
                    style={inlineStyle.modal}
                    open={this.state.modalOpen}
                    onClose={()=>{this.setState({modalOpen:false})}}
                >
                    <Modal.Header>Edit Product</Modal.Header>
                    <Modal.Content>
                        {this.state.activeProduct && <ProductTable product={this.state.activeProduct} />}
                    </Modal.Content>
                </Modal>
            </div>
        );
    }


}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OverviewTable);



// WEBPACK FOOTER //
// ./src/scenes/Inventory/components/OverviewTable/index.js